export default "<div class=\"hoofdDiv\">\n<router-outlet></router-outlet>\n</div>\n"